"use strict";
const _ = require("lodash");

module.exports = (value) => {
    if (!_.isString(value)) {
        return value;
    }

    const map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "/": "&#x2F;",
    };

    return value.replace(/[&<>"'/]/g, (char) => map[char]);
};
